import * as React from 'react';
import { LazyBackgroundImage } from 'ui';
import { LegacyPlaceholderBusinessImage } from '@tock/images';
import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    media: {
      alignSelf: 'normal',
      height: 0,
      opacity: 0,
      paddingTop: theme.mediaRatios.threeTwo,
      transition: `${theme.transitions.duration.enteringScreen}ms opacity ${theme.transitions.easing.easeInOut}`,
    },
    inView: {
      opacity: 1,
    },
    rounded: {
      borderRadius: 3,
    },
  })
);

interface Props {
  image: string;
  altText: string;
  dominantColor: string;
  rounded?: boolean;
}

export const CardImage: React.FunctionComponent<Props> = ({
  image,
  dominantColor,
  rounded,
  altText,
}) => {
  const classes = useStyles();

  return (
    <LazyBackgroundImage
      aria-label={altText}
      backgroundColor={dominantColor}
      backgroundPosition="center"
      backgroundRepeat="no-repeat"
      backgroundSize="cover"
      className={clsx(classes.media, { [classes.rounded]: rounded })}
      role="img"
      url={image ? image : LegacyPlaceholderBusinessImage}
      inViewClassName={classes.inView}
    />
  );
};
